const TYPES = {
  ADD_CMS_DATA: "ADD_CMS_DATA",
  ADD_NOTIFICATION_DATA: "ADD_NOTIFICATION_DATA",
  ADD_REGION: "ADD_REGION",
  SET_SELECTED_REGION: "SET_SELECTED_REGION",
  CLEAR_SELECTED_REGION: "CLEAR_SELECTED_REGION",
  SET_SELECTED_OBSERVATION: "SET_SELECTED_OBSERVATION",
  ADD_FORECAST: "ADD_FORECAST",
  ADD_RECAPTCHA_KEY: "ADD_RECAPTCHA_KEY",
  ADD_OBSERVATION: "ADD_OBSERVATION",
  SET_SHOW_RECENT_PUBLIC_OBS: "SET_SHOW_RECENT_PUBLIC_OBS",
  CLEAR_OBSERVATIONS_FILTERS: "CLEAR_OBSERVATIONS_FILTERS",
  UPDATE_OBSERVATIONS_FILTERS: "UPDATE_OBSERVATIONS_FILTERS"
};

export default TYPES;
